import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class NGLTowerConstraintsAPI {
    static getScreenData(data) {
        return RestEndPoint.callAzureFunction(
            APIUrlConstants.GetNGLTowerConstraints,
            'POST',
            AppConstants.APP_BACKEND_HOST_KEY,
            data
        );
    }

    static getComments(data) {
        return RestEndPoint.callAzureFunction(
            APIUrlConstants.GetNGLTowerConstraintsComments,
            'POST',
            AppConstants.APP_BACKEND_HOST_KEY,
            data
        )
    }

    static saveScreenData(data) {
        return RestEndPoint.callAzureFunction(
            APIUrlConstants.SaveNGLTowerConstraints,
            'POST',
            AppConstants.APP_BACKEND_HOST_KEY,
            data
        );
    }

    static saveComments(data) {
        return RestEndPoint.callAzureFunction(
            APIUrlConstants.SaveNGLTowerConstraintsComments,
            'POST',
            AppConstants.APP_BACKEND_HOST_KEY,
            data
        );
    }
}
